import React from 'react';
import './About.css';

const AboutMission = () => {
  return (
    <section id="mission" className="mission section">
      <div className="mission-content">
        <div className="mission-text">
          <h2 className="about-title">Our Mission</h2>
          <div className="about-description">
            <p>
              To help people return to what matters — nature, peace, and belonging — by building
              homes that breathe with the hills. From villas to domes and cabins, our spaces are
              crafted with light, views, and honest materials, balancing privacy with a sense of
              community.
              <br />
              <br />
              We commit to nature-first development, low-impact infrastructure, and design that
              serves for decades: mindful siting, water sensitivity, and gentle amenities like a
              clubhouse, wellness corners, co-working, kids’ play, and walking trails. The goal is
              simple: quiet comfort today, responsible stewardship for tomorrow.
            </p>
          </div>
        </div>
        <div className="mission-image">
          <img src="/about_mission.jpg" alt="Amoda Sari entrance" />
        </div>
      </div>
    </section>
  );
};

export default AboutMission;
